import { debtorInfo } from '@/server/debtor'
const state = {
  info: {
    accuser: {}
  }
}
const mutations = {
  SET_INFO: (state, data) => {
    state.info = data
  },
  Change_INFO: (state, data) => {
    state.info[data.key] = data.value
  }
}
const actions = {
  async getInfo ({ commit, state, dispatch }, data) {
    return await new Promise((resolve, reject) => {
      debtorInfo(data).then(e => {
        e.info.myclear = e.info.is_clear      //自定結清 
        e.info.is_clear = 0     //將結清干费  
        resolve(e)
        commit('SET_INFO', e.info)
      })
    })
  },
  async Infoput ({ commit }, data = { key: null, value: null }) {       //操作改变 info 详情
    commit('Change_INFO', data)
  },
  async SetClear ({ commit }, data) {
    commit('Change_INFO', { key: "is_clear", value: data })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
